import(/* webpackMode: "eager" */ "/codebuild/output/src562611367/src/src/app/global-error.tsx");
